// 需要顯示step的路徑
import bd from './bd';
import { routesLoanApply } from './aplCatlPon4300';
import { routesMultiEnotifyApply } from './aplCatlMultiENotify';
import { routesCreditCard } from './aplCatlCreditCardExp';
import { routesMultiPayChange } from './aplCatlMultiPayChange';
import { routesACH } from './aplCatlACH';
import { routesLinePnp } from './aplCatlLinePnp';
import { routesCreditCardAuth } from '@/router/modules/aplCatlCreditCardAuth';
export default [
    ...bd,
    ...routesLoanApply,
    ...routesMultiEnotifyApply,
    ...routesMultiPayChange,
    ...routesACH,
    ...routesCreditCard,
    ...routesLinePnp,
    ...routesCreditCardAuth,
];
